// extracted by mini-css-extract-plugin
module.exports = {"ovWrapper":"LogoOverlay_ovWrapper__Vjg7P","logo":"LogoOverlay_logo__7R3Q3","logo2":"LogoOverlay_logo2__2RrXA","banner":"LogoOverlay_banner__2TiNt"};